var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ModalLayout',{attrs:{"title":_vm.title,"mStyle":'width: 1024px;'},on:{"close":_vm.handleClose}},[_c('BoardRead',{attrs:{"webpartParam":_vm.readParams,"isModal":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }